import { HTMLAttributes } from 'react';

interface FormEntryProps extends HTMLAttributes<HTMLElement> {
    children?: React.ReactNode;
}

function FormEntry({ children, ...props }: FormEntryProps) {
    return (
        <section className="form__entry" {...props}>
            {children}
        </section>
    );
}

export default FormEntry;